import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="width:22px;height:22px;border-radius:50% 50% 50% 0;background:#10B981;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 5px rgba(0,0,0,.45)"></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

function Fit({ positions }) {
  const map = useMap();
  useEffect(() => {
    if (positions.length === 1) map.setView(positions[0], 12);
    else if (positions.length > 1) map.fitBounds(positions, { padding: [40, 40], maxZoom: 13 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positions.length]);
  return null;
}

export default function SearchMap({ marinas }) {
  const pins = marinas.filter((m) => m.lat != null && m.lon != null).map((m) => ({ ...m, ll: [m.lat, m.lon] }));
  if (!pins.length) return null;

  return (
    <div className="overflow-hidden rounded-sm border border-border" data-testid="search-map">
      <MapContainer center={pins[0].ll} zoom={11} style={{ height: "320px", width: "100%" }} scrollWheelZoom>
        <Fit positions={pins.map((p) => p.ll)} />
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution="Tiles &copy; Esri"
          maxNativeZoom={19}
          maxZoom={20}
        />
        {pins.map((p, i) => (
          <Marker key={i} position={p.ll} icon={pinIcon}>
            <Tooltip>
              <b>{p.name}</b> — 1 θέση διαθέσιμη
            </Tooltip>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
